<template> 
  <div> 
    <div class="ms-4">
        <div class="page-title flex-row me-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('stockcost_list') }}
            </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li>    
                <li class="breadcrumb-item text-primary">{{ $t('stock_reports') }}</li> 
                <li class="breadcrumb-item text-gray-600">{{ $t('stockcost_list') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>  
    </div>
    <div class="content flex-row-fluid mt-4" id="kt_content">
        <div class="card">
            <div class="row fv-row border-0 pt-6 px-9">
                <div class="col-lg-9">
                    <div class="fv-row mb-4 row">
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('start_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.first_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('end_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.last_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('stock_group') }}</span>
                            </label>
                            <Select2 v-model="this.form.stock_group" :options="this.stockGroupList" :settings="{ width: '100%' }"/>  
                        </div>  
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('stock_name') }}</span>
                            </label> 
                            <Select2 v-model="this.form.stock_name" :options="this.stockNameList" :settings="{ width: '100%' }"/>  
                        </div>
                         <div class="col-xxl col-md-6 col-sm-6 col-xs-12 text-nowrap">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('product_group') }}</span>
                            </label> 
                            <Select2 v-model="this.form.product_group" :options="this.productGroupList" :settings="{ width: '100%' }" @select="onChangeProductGroup()"/> 
                        </div>
                         <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('product_type') }}</span>
                            </label>
                            <Select2 v-model="this.form.product_type" :options="this.productTypeList" :settings="{ width: '100%' }"/> 
                        </div>
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('inout') }}</span>
                            </label>
                            <Select2 v-model="this.form.in_out" :options="this.inOutList" :settings="{ width: '100%' }"/> 
                        </div>
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12 text-nowrap">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('check_count_differences') }}</span>
                            </label> 
                            <Select2 v-model="this.form.with_differences" :options="this.diffList" :settings="{ width: '100%' }"/>  
                        </div>
                        <div class="col-xxl col-md-6 col-sm-6 col-xs-12 text-nowrap ">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('transaction_type') }}</span>
                            </label> 
                            <Select2 v-model="this.form.transaction_type" :options="this.transactionTypeList" :settings="{ width: '100%' }" @select="onChangeTransactionType($event, true)"/>  
                        </div>
                        <!-- <div class="col-xxl col-md-6 col-sm-6 col-xs-12 text-nowrap ">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('transaction_sub_type') }}</span>
                            </label> 
                            <Select2 v-model="this.form.transaction_subtype" :options="this.transactionSubTypeList" :settings="{ width: '100%' }"/>  
                        </div> -->
                    </div>  
                </div>
                <div class="col-lg-3">
                    <div class="d-flex justify-content-end my-5" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(74,'R')"> 
                        <Popper hover placement="top">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper>
                        <button type="button" class="btn btn-light-primary border border-primary" @click="getListData()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                            </svg>
                            </span>
                            <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                            <span class="indicator-progress" v-if="this.isListProgressing">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button> 
                    </div>
                    <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                        <div class="fw-bolder me-5">
                        <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                        <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                    </div>
                </div>
            </div>
            <div class="card-body pt-3">
                <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div>
                        <div class="table-responsive min-h-300px">

                            <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                            <DxDataGrid id="gridContainer"
                                    :show-borders="true"
                                    key-expr="id"
                                    :data-source="lists"
                                    :allow-column-reordering="true" 
                                    :allow-column-resizing="true"
                                    :column-auto-width="true"
                                    :customize-columns="onCustomizeColumn"
                                    :row-alternatin-enabled="true"
                                    :hover-state-enabled="true" 
                                    :show-row-lines="true" 
                                    :ref="'dataGrid'"
                                    @exporting="this.$onExporting($event , 'Stock-Transaction-List')">   
                                    <DxFilterRow :visible="true"/>
                                    <DxHeaderFilter :visible="true"/>
                                    <DxGroupPanel :visible="true"/>      
                                    <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                    <DxPaging :page-size="pageSize"/>
                                    <DxPager :visible="false" :allowed-page-sizes="pageSizesLists" :show-page-size-selector="showPageSizeSelectorLists" :show-info="true" :show-navigation-buttons="true"/>    
                                    <DxSearchPanel :visible="true"/>
                                    <DxScrolling
                                        mode="virtual"
                                        row-rendering-mode="virtual"
                                    />
                                    <DxColumn data-field="record_date" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="record-date-header" :caption="$t('record_date')" cell-template="record_date-cell-template"/>
                                    <DxColumn data-field="stock_account_name" :caption="$t('stock')" cell-template="stock_account_name-cell-template"/>
                                    <DxColumn data-field="stk_product_code" :caption="$t('product_code')" header-cell-template="product-code-header"/>
                                    <DxColumn data-field="transaction_type_name" :caption="$t('transaction_type')" header-cell-template="transaction-type-header" cell-template="transaction_type_name-cell-template"/> 
                                    <DxColumn data-field="invoice_type_name" :caption="$t('transaction_type')" header-cell-template="invoice-type-header" cell-template="invoice_type_name-cell-template"/> 
                                    <DxColumn data-field="in_out_name" :caption="$t('in_out')" header-cell-template="inout-type-header" cell-template="in_out_name-cell-template"/>   
                                    <DxColumn data-field="transaction_no" :caption="$t('transaction_no')" header-cell-template="transaction-no-header" cell-template="transaction_no-cell-template"/>
                                    <DxColumn data-field="price" :sorting-method="this.$numericSort" :caption="$t('price')" alignment="right" cell-template="price-cell-template"/>
                                    <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/> 
                                    <DxColumn data-field="rate" :caption="$t('rate')" alignment="right" cell-template="rate-cell-template"/> 
                                    <DxColumn data-field="discount" :sorting-method="this.$numericSort" :caption="$t('discount')" alignment="right" cell-template="discount-cell-template"/>
                                    <DxColumn data-field="quantity1" :sorting-method="this.$numericSort" :caption="$t('quantity')" alignment="right" cell-template="quantity1-cell-template"/>
                                    <DxColumn data-field="unit1_name" :caption="$t('unit')" cell-template="unit1_name-cell-template"/>
                                    <DxColumn data-field="total_price" :sorting-method="this.$numericSort" :caption="$t('total_price')" alignment="right" header-cell-template="total-price-header" cell-template="total_price-cell-template"/>
                                    <DxColumn data-field="discount_amount" :sorting-method="this.$numericSort" :caption="$t('discount_amt')" alignment="right" header-cell-template="discount-amount-header" cell-template="discount_amount-cell-template"/> 
                                    <DxColumn data-field="net_price" :sorting-method="this.$numericSort" :caption="$t('net_price')" alignment="right" header-cell-template="net-price-header" cell-template="net_price-cell-template"/> 
                                    <DxColumn data-field="tax_amount" :sorting-method="this.$numericSort" :caption="$t('tax_amt')" alignment="right" header-cell-template="tax-amount-header" cell-template="tax_amount-cell-template"/> 
                                    <DxColumn data-field="gross_amount" :sorting-method="this.$numericSort" :caption="$t('gross_amt')" alignment="right"  header-cell-template="gross-amount-header" cell-template="gross_amount-cell-template"/>  
                                    <DxColumn data-field="cost" :caption="$t('cost_amt')" alignment="right"  header-cell-template="cost-amount-header" cell-template="cost-cell-template"/> 
                                    <DxColumn data-field="profit" :caption="$t('profit')" alignment="right" cell-template="profit-cell-template"/> 
                                    <DxColumn data-field="tax_rate" :sorting-method="this.$numericSort" :caption="$t('tax_rate')" alignment="right" header-cell-template="tax-rate-header" cell-template="tax_rate-cell-template"/> 
                                    <DxColumn data-field="product_group_name" :caption="$t('product_group')" header-cell-template="product-group-header" cell-template="product_group_name-cell-template"/> 
                                    <DxColumn data-field="product_type_name" :caption="$t('product_type')" header-cell-template="product-type-header" cell-template="product_type_name-cell-template"/> 
                                    <DxColumn data-field="quantity2" :caption="$t('quantity_2')" :sorting-method="this.$numericSort"  alignment="right" cell-template="quantity2-cell-template"/>
                                    <DxColumn data-field="option_date"  data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('option_date')" header-cell-template="option-date-header" cell-template="option_date-cell-template"/>
                                    <DxColumn data-field="id" header-cell-template="offset-detail-header" :caption="$t('offsets')" :allow-filtering="false" cell-template="has_detail-cell-template" :allow-exporting="false"/>

                                    <template #headerLocalTemplate="{ data: data }">
                                        <div v-html="setColumnForInOut(data)"></div> 
                                    </template>
                                    <template #record-date-header>
                                        <div>{{ $t('record_date') }}</div>
                                    </template>
                                    <template #product-code-header>
                                        <div>{{ $t('product_code') }}</div>
                                    </template>
                                    <template #transaction-type-header>
                                        <div>{{ $t('transaction_type') }}</div>
                                    </template>
                                    <template #invoice-type-header>
                                        <div>{{ $t('invoice_type') }}</div>
                                    </template>
                                    <template #inout-type-header>
                                        <div>{{ $t('in_out') }}</div>
                                    </template>
                                     <template #product-group-header>
                                        <div>{{ $t('product_group') }}</div>
                                    </template>
                                     <template #product-type-header>
                                        <div>{{ $t('product_type') }}</div>
                                    </template>
                                    <template #transaction-no-header>
                                        <div>{{ $t('transaction_no') }}</div>
                                    </template>
                                    <template #transaction-date-header>
                                        <div>{{ $t('transaction_date') }}</div>
                                    </template>
                                    <template #option-date-header>
                                        <div>{{ $t('option_date') }}</div>
                                    </template>
                                    <template #total-price-header>
                                        <div>{{ $t('total_price') }}</div>
                                    </template>
                                    <template #discount-amount-header>
                                        <div>{{ $t('discount_amount') }}</div>
                                    </template>
                                    <template #net-price-header>
                                        <div>{{ $t('net_price') }}</div>
                                    </template>
                                    <template #tax-amount-header>
                                        <div>{{ $t('tax_amount') }}</div>
                                    </template>
                                    <template #tax-rate-header>
                                        <div>{{ $t('tax_rate') }}</div>
                                    </template>
                                    <template #gross-amount-header>
                                        <div>{{ $t('gross_amount') }}</div>
                                    </template>
                                      <template #cost-amount-header>
                                        <div>{{ $t('cost_amount') }}</div>
                                    </template>
                                    <template #offset-detail-header>
                                        <div>{{ $t('offsets') }}</div>
                                    </template> 

                                    <!-- Cell Templates --> 
                                    <template #record_date-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ previewDate(data.data.record_date) }} 
                                        </span>
                                    </template> 
                                    <template #stock_account_name-cell-template="{ data }">
                                        <span class="align-middle"> 
                                            {{ data.data.stock_account_name }} <small v-if="data.data.is_bundle_product == 1" class="ms-2 badge badge-sm badge-success">{{ $t('bundle') }}</small>
                                        </span>
                                    </template> 
                                    <template #transaction_type_name-cell-template="{ data }">
                                        <span class="align-middle" :class="{ 'text-primary': data.data.transaction_type == '11', 'text-info': data.data.transaction_type == '12'}">
                                            {{ data.data.transaction_type_name }}
                                        </span>
                                    </template> 
                                    <template #invoice_type_name-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.invoice_type_name }}
                                        </span>
                                    </template> 
                                    <template #in_out_name-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.in_out_name }}
                                        </span>
                                    </template> 
                                    
                                    <template #transaction_no-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.transaction_no }}
                                        </span> 
                                    </template> 
                                        <template #price-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.price }}
                                        </span> 
                                    </template> 
                                    <template #currency-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.currency }}
                                        </span>
                                    </template> 
                                    <template #rate-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.rate }}
                                        </span>
                                    </template> 
                                    <template #discount-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.discount }}
                                        </span>  
                                    </template> 
                                    <template #quantity1-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.quantity1 }}
                                        </span> 
                                    </template> 
                                    <template #unit1_name-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.unit1_name }}
                                        </span> 
                                    </template> 
                                        <template #total_price-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.total_price }}
                                        </span>
                                    </template> 
                                    <template #discount_amount-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.discount_amount }}
                                        </span> 
                                    </template> 
                                        <template #net_price-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.net_price }}
                                        </span>
                                    </template> 
                                        <template #tax_amount-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.tax_amount }}
                                        </span>
                                    </template> 
                                        <template #gross_amount-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.gross_amount }}
                                        </span> 
                                    </template> 
                                    <template #cost-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.cost }}
                                        </span> 
                                    </template> 
                                    <template #profit-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.profit }}
                                        </span>
                                    </template> 
                                    <template #tax_rate-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.tax_rate }}
                                        </span> 
                                    </template> 
                                        <template #product_group_name-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.product_group_name }}
                                        </span>
                                    </template> 
                                    <template #product_type_name-cell-template="{ data }">
                                        <span class="align-middle">
                                            {{ data.data.product_type_name }}
                                        </span>
                                    </template> 
                                    <template #quantity2-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ data.data.quantity2 }}
                                        </span>
                                    </template> 
                                    <template #option_date-cell-template="{ data }">
                                        <span class="align-middle text-end">
                                            {{ previewDate(data.data.option_date) }}
                                        </span>
                                    </template> 
                                    <template #has_detail-cell-template="{ data }">
                                        <span class="align-middle">  
                                            <button class="btn btn-sm btn-icon btn-secondary btn-icon-dark btn-text-dark w-20px h-20px" @click="viewDetail(data.data.id)" v-if="data.data.has_detail == 1"
                                                    data-bs-toggle="modal" data-bs-target="#kt_modal_view_detail" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                                <span class="svg-icon svg-icon-muted icon-size-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.7 18.9L18.6 15.8C17.9 16.9 16.9 17.9 15.8 18.6L18.9 21.7C19.3 22.1 19.9 22.1 20.3 21.7L21.7 20.3C22.1 19.9 22.1 19.3 21.7 18.9Z" fill="currentColor"/>
                                                <path opacity="0.3" d="M11 20C6 20 2 16 2 11C2 6 6 2 11 2C16 2 20 6 20 11C20 16 16 20 11 20ZM11 4C7.1 4 4 7.1 4 11C4 14.9 7.1 18 11 18C14.9 18 18 14.9 18 11C18 7.1 14.9 4 11 4ZM8 11C8 9.3 9.3 8 11 8C11.6 8 12 7.6 12 7C12 6.4 11.6 6 11 6C8.2 6 6 8.2 6 11C6 11.6 6.4 12 7 12C7.6 12 8 11.6 8 11Z" fill="currentColor"/>
                                                </svg>
                                                </span>
                                            </button> 
                                        </span> 
                                    </template>  

                                        <DxSummary>
                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_date"/>
                                            
                                        </DxSummary>

                                <DxSummary :calculate-custom-summary="setDetailSummaries">
                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_date"/>

                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="price"
                                        summary-type="custom"
                                        show-in-column="price"
                                        display-format="{0}"
                                    />  
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="discount"
                                        summary-type="custom"
                                        show-in-column="discount"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="quantity1"
                                        summary-type="custom"
                                        show-in-column="quantity1"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="total_price"
                                        summary-type="custom"
                                        show-in-column="total_price"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="discount_amount"
                                        summary-type="custom"
                                        show-in-column="discount_amount"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="net_price"
                                        summary-type="custom"
                                        show-in-column="net_price"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="tax_amount"
                                        summary-type="custom"
                                        show-in-column="tax_amount"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="gross_amount"
                                        summary-type="custom"
                                        show-in-column="gross_amount"
                                        display-format="{0}"
                                    /> 
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="tax_rate"
                                        summary-type="custom"
                                        show-in-column="tax_rate"
                                        display-format="{0}"
                                    /> 
                                    <DxTotalItem
                                        name="price"
                                        summary-type="custom"
                                        show-in-column="price"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="discount"
                                        summary-type="custom"
                                        show-in-column="discount"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="quantity1"
                                        summary-type="custom"
                                        show-in-column="quantity1"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="total_price"
                                        summary-type="custom"
                                        show-in-column="total_price"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="net_price"
                                        summary-type="custom"
                                        show-in-column="net_price"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="tax_amount"
                                        summary-type="custom"
                                        show-in-column="tax_amount"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="gross_amount"
                                        summary-type="custom"
                                        show-in-column="gross_amount"
                                        display-format="{0}"
                                    />
                                    <DxTotalItem
                                        name="tax_rate"
                                        summary-type="custom"
                                        show-in-column="tax_rate"
                                        display-format="{0}"
                                    />
                                </DxSummary>

                                    <DxStateStoring
                                        :enabled="true"
                                        type="custom"
                                        :storage-key="this.storageKey"
                                        :ref="dataGrid" 
                                        :saving-timeout="1000"
                                        :custom-load="LoadDXState"
                                    />
                            </DxDataGrid>     
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>  
    
    <div class="modal fade" id="kt_modal_view_detail" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
            <div class="modal-content"  >
                <div class="modal-header bg-primary" id="kt_modal_add_user_header">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">
                        {{ $t('stock_offset_detail') }}                      
                    </h2>  
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y" :class="{'overlay overlay-block': this.isDocketItemSaving == true}">
                    <form class="form fv-plugins-bootstrap5 fv-plugins-framework"> 
                        <div class="row"> 
                              <div class="card p-0">  
                                    <div class="card-body px-3">
                                            <div>
                                                <div class="table-responsive min-h-300px">
                                                    <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" :data-source="detailList" :allow-column-reordering="true"  :allow-column-resizing="true" :column-auto-width="true"  @exporting="this.$onExporting($event , 'Stock-Transaction-List')">
                                                        <DxFilterRow :visible="true"/>
                                                        <DxHeaderFilter :visible="true"/>
                                                        <DxGroupPanel :visible="true"/>      
                                                        <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                        <DxPaging :page-size="10"/>
                                                        <DxPager :visible="false" :allowed-page-sizes="pageSizesDetailList" :show-page-size-selector="showPageSizeSelectorDetailList" :show-info="true" :show-navigation-buttons="true"/>    
                                                        <DxSearchPanel :visible="true"/>
                                                        
                                                        <DxColumn data-field="offset_creation_date" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('offset_create_date')" />
                                                        <DxColumn data-field="quantity" :sorting-method="this.$numericSort" :caption="$t('quantity')" alignment="right"/>
                                                        <DxColumn data-field="transaction_type_name_in" :caption="$t('transaction_type_in')" /> 
                                                        <DxColumn data-field="transaction_sub_type_in" :caption="$t('transaction_subtype_in')"/>
                                                        <DxColumn data-field="invoice_no_in" :caption="$t('invoice_no_in')"/>
                                                        <DxColumn data-field="transaction_date_in" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('in_transaction_date')"/> 
                                                        <DxColumn data-field="stock_price_in" :sorting-method="this.$numericSort" :caption="$t('stock_price_in')" alignment="right"/> 
                                                        <DxColumn data-field="stock_price_total_in" :sorting-method="this.$numericSort" :caption="$t('stock_price_total_in')" alignment="right"/> 
                                                        <DxColumn data-field="transaction_type_name_out" :caption="$t('transaction_type_out')"/> 
                                                        <DxColumn data-field="transaction_sub_type_out" :caption="$t('transaction_subtype_out')"/> 
                                                        <DxColumn data-field="invoice_no_out" :caption="$t('invoice_no_out')"/> 
                                                        <DxColumn data-field="transaction_date_out" :caption="$t('out_transaction_date')" data-type="date" alignment="right" format="dd.MM.yyyy" /> 
                                                        <DxColumn data-field="stock_price_out" :sorting-method="this.$numericSort" :caption="$t('stock_price_out')" alignment="right"/> 
                                                        <DxColumn data-field="stock_price_total_out" :sorting-method="this.$numericSort" :caption="$t('stock_price_total_out')" alignment="right"/>   

                                                        <DxSummary>
                                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="offset_creation_date"/>
                                                        </DxSummary>
                                                    </DxDataGrid> 
                                            </div> 
                                        </div>
                                    </div> 
                                </div>
                        </div>
                    </form>
                    <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isDocketItemSaving == true">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $t('loading') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
  </div>  
</template>
<script>
import axios from 'axios' 

import moment from 'moment'; 
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn,DxGroupItem, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
  name: "StockCostList",
  components:{
    DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn,DxGroupItem, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxScrolling
  }, 
  data() {
    return {
        storageKey: 'dx_' + this.$options.name,
        pageSize: 100,
        pageSizeDetailList: 10,
        page: 1, 
        page_size: 20,
        lists: [],
        form:  {
            first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            last_date: moment(),
            in_out: 1,
            stock_group: '-1',
            stock_name: '-1',
            product_group: '-1',
            product_type: '-1',
            with_differences: 1,
            transactionTypeSelection: { id: 0, text: this.$t('all')},
            transaction_type: '-1',
        },
        isListProgressing: false,
        detailList: [],
        isFilterOpen: false,
        inOutList: [{ id: 1, text: this.$t('incoming') },{ id: 2, text: this.$t('outgoing') }],
        diffList: [{ id: 0, text: this.$t('no') },{ id: 1, text: this.$t('yes') }],
        stockGroupList: [],
        productGroupList: [],
        productTypeList: [],
        stockNameList: [],
        summary: {
            discount_amount_local: null,
            gross_amount_local: null,
            total_price_local: null,
            quantity1: null,
            quantity2: null,
            tax_amount_local: null,
            cost: null,
            profit: null
        },
        menuSelection: '/StockCostHelppage',
        iconView : false,
        transactionTypeList:[],
        transactionSubTypeList:[]
    };
  },
  computed: {
   setColumnForInOut(){
        return (value)=>{
                var newCaption = value.column.caption;
                if(this.form.in_out == 1 && value.column.caption == 'Cost Amount'){
                    newCaption = this.$t('sold') + '<br>' + this.$t('amount');
                }
                if(this.form.in_out == 1 && value.column.caption == 'Profit Amount'){
                    newCaption = this.$t('remain') + '<br>' + this.$t('amount');
                }
                if(this.form.in_out == 2 && value.column.caption == 'Cost Amount'){
                    newCaption = this.$t('cost') + '<br>' + this.$t('amount');
                }
                if(this.form.in_out == 2 && value.column.caption == 'Profit Amount'){
                    newCaption = this.$t('profit') + '<br>' + this.$t('amount');
                }
                return newCaption;        
        }
   },
   previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    showPageSizeSelectorLists() {
        return this.lists.length > this.pageSize;
    },
    pageSizesLists() {
        let arr = [];
        let x = 1;
        let loop = (this.lists.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(1000);
        if(loop > 1) arr.push('all');
        return arr;
    },
    showPageSizeSelectorDetailList() {
        return this.detailList.length > this.pageSizeDetailList;
    },
    pageSizesDetailList() {
        let arr = [];
        let x = 1;
        let loop = (this.detailList.length / this.pageSizeDetailList);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSizeDetailList * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: {
    getData(){
        this.$Progress.start();
        const parameters = {
            session_id: this.$getUser().session_id,
            list_types: [{ list_type: 6, list_name: "stock_group"}],
            list_name: ["currency", "account_setting", "product_group"],
            account_type: 7 // yalnızca account settings listesi çekilecek ise gerekli
        };  
        
        const parameters2 = {
            session_id: this.$getUser().session_id,
            tip: 2 //Transaction Types
        }; 
        
        const requestOne =  axios.post('/api/Helper/GetMultiLists', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}); 
        const requestThree =  axios.post('/api/GetCompanyAccounts/GetStockAccounts', parameters, {'Content-Type': 'application/json'});
        const requestFour =  axios.post('/api/Helper/GetConst', parameters2, {'Content-Type': 'application/json'});        
        axios.all([requestOne, requestTwo, requestThree, requestFour]).then(axios.spread((...responses) => {                
            this.stockGroupList = responses[0].data.stock_group; 
            this.stockGroupList.unshift({ id: '-1', text: this.$t('all')}); 
            this.productGroupList = responses[1].data.product_group;
            this.stockNameList = !responses[2].data.error ? responses[2].data.account_data : []; 
            this.stockNameList.forEach(element => {
                element.name = this.$unlock(element.name);
                element.account_id = this.$unlock(element.account_id);
                element.text = this.$unlock(element.text);
            });
            this.stockNameList.unshift({ id: '-1', text: this.$t('all')});
            this.productGroupList.unshift({ id: '-1', text: this.$t('all')});
            this.productTypeList.unshift({ id: '-1', text: this.$t('all')}); 
            this.productGroupList.forEach((value) => {
            if(value.is_default) {
                this.form.product_group_id = value.id;
            }
            });

            this.transactionTypeList = responses[3].data;
            this.transactionTypeList.unshift({ id: '-1', text: this.$t('all')});
            this.transactionSubTypeList.unshift({ id: 0, text: this.$t('all')});


            this.$Progress.finish();   
        }))
        .catch(errors => { 
            console.error(errors); 
            this.$Progress.finish();
        });  
    },
    getListData() {
        this.$Progress.start();
        this.isListProgressing = true;
        this.form.first_date = (this.form.first_date == null || this.form.first_date == '') ? moment() : this.form.first_date;
        this.form.last_date = ( this.form.last_date == null || this.form.last_date == '') ? moment () : this.form.last_date;
        const params = {
            session_id: this.$getUser().session_id,
            first_date: moment(this.form.first_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            last_date: moment(this.form.last_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            in_out: this.form.in_out,
            stock_group: null,
            stock_name: null,
            product_group: null,
            product_type: null,
            with_differences: this.form.with_differences,
            transaction_type : null,
            // transaction_subtype: null
        };
        params.stock_group = this.form.stock_group == '-1'? null : this.form.stock_group;
        params.stock_name = this.form.stock_name == '-1'? null : this.form.stock_name;
        params.product_group = this.form.product_group == '-1'? null : this.form.product_group;
        params.product_type = this.form.product_type == '-1'? null : this.form.product_type;
        params.transaction_type = this.form.transaction_type == '-1' ? null : this.form.transaction_type;
        // params.transaction_subtype = this.form.transaction_subtype == 0 ? null : this.form.transaction_subtype;
        axios.post('/api/Transaction/GetStockCostList', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.lists = !response.data.error ? response.data.transactions : [];
            this.summary = response.data.summary;
            this.page = 1;
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch((error) => {
            console.error(error);
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        });  
    },
    viewDetail(id){
        this.detailList = [];
        this.$Progress.start(); 
        const queryParameter = {
            session_id: this.$getUser().session_id,
            stock_transaction_id: id
        };   
        axios.post('/api/Transaction/GetAllStockTransactionDetail', queryParameter, {'Content-Type': 'application/json'}) 
            .then((response) => {  
                this.detailList = !response.data.error ? response.data : [];
                this.$Progress.finish();
            })
            .catch(() => {
                this.$Progress.finish();
            });
    },
    setCriteriasToDefault() {   
        this.form = {
            first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            last_date: moment(),
            in_out: 1,
            stock_group: '-1',
            stock_name: '-1',
            product_group: '-1',
            product_type: '-1',
            with_differences: 1,
            transactionTypeSelection: { id: 0, text: this.$t('all')},
            transaction_type: '-1',
        };
        this.lists = [];
    },
    onChangeProductGroup() {
        this.productTypeList = [];
        const params = {
            session_id: this.$getUser().session_id,
            parent_id: this.form.product_group
        };
        axios.post("/api/Helper/GetProductTypeParentList", params, {'Content-Type': 'application/json'}).then((response) => { 
            this.productTypeList = response.data;
            this.productTypeList.unshift({ id: '-1', text: this.$t('all')}); 
            this.form.product_type = this.productTypeList[0].id;
            this.productTypeList.forEach((value) => {
                if(value.is_default) {
                    this.form.product_type = value.id;
                }
            });
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error);
            this.$Progress.finish();
        });
    },
    setSummaries(options){
        if(options.name == "discount_amount") { options.totalValue = this.summary.discount_amount_local }
        if(options.name == "gross_amount") { options.totalValue = this.summary.gross_amount_local }
        if(options.name == "total_price") { options.totalValue = this.summary.total_price_local }
        if(options.name == "quantity1") { options.totalValue = this.summary.quantity1 }
        if(options.name == "quantity2") { options.totalValue = this.summary.quantity2 }
        if(options.name == "tax_amount") { options.totalValue = this.summary.tax_amount_local } 
        if(options.name == "cost") { options.totalValue = this.summary.cost } 
        if(options.name == "profit") { options.totalValue = this.summary.profit } 
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {   
                     if(column.dataField == 'cost'){ 
                         column.caption = this.$t('cost_amount');
                         column.headerCellTemplate = 'headerLocalTemplate';
                     }
                     if(column.dataField == 'profit'){ 
                         column.caption = this.$t('profit_amount');
                         column.headerCellTemplate = 'headerLocalTemplate';
                     }
                });  
            } 
        } 
    },
    /** DX STATE OPERATIONS **/  
    LoadDXState() {
        return JSON.parse(sessionStorage.getItem(this.storageKey));
    }, 
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/StockCostHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    setDetailSummaries(options){  
     const optionNames = ["price", "discount", "quantity1", "total_price", "discount_amount", "net_price", "tax_amount", "gross_amount", "tax_rate"]; 
        optionNames.forEach(item => {
            if(options.name == item){
                if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                else if(options.summaryProcess === 'calculate'){
                    var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                    (options.totalValue += itemValue);
                }
                else if(options.summaryProcess === 'finalize'){ 
                    options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                }
            }
        });
    },
    // onChangeTransactionType(e, isSetDefault){
    //     this.form.transactionTypeSelection = e;
    //     var finalDeger = 0;
    //     if(e.tip == 2 && e.deger == 5){
    //         finalDeger = 1; // Invoice için
    //     }
    //     if(e.tip == 2 && e.deger == 6){
    //         finalDeger = 3; // Bank için
    //     }
    //     if(e.tip == 2 && e.deger == 7){
    //         finalDeger = 3; // Cash için
    //     }
    //     if(e.tip == 2 && e.deger == 10){
    //         finalDeger = 10; // Cheque için
    //     } 
    //     if(finalDeger == 0){
    //         this.transactionSubTypeList = [];
    //         this.transactionSubTypeList.unshift({ id: 0, text: this.$t('all')}); 
    //         if(isSetDefault) {
    //             this.form.transaction_subtype = 0;
    //         }
    //         return;
    //     }
    //     this.$Progress.start();
    //     this.transactionSubTypeList = [];
    //     const params = {
    //         session_id: this.$getUser().session_id,
    //         tip: finalDeger //Transaction Types
    //     };
    //     axios.post('/api/Helper/GetConst', params, {'Content-Type': 'application/json'})
    //     .then((response) => {
    //         this.transactionSubTypeList = response.data; 
    //         this.transactionSubTypeList.unshift({ id: 0, text: this.$t('all')}); 
    //         if(isSetDefault) {
    //             this.form.transaction_subtype = 0;
    //         }
    //         this.$Progress.finish();

    //     })
    //     .catch((error) => {
    //         console.error(error); 
    //         this.$Progress.finish(); 
    //     });
    // },
  },
  created() {
    this.helpPageViewIcon();
    this.$removeSessionStorage('record_id');
    this.getData();
    this.lists = [];
  }
}; 
</script>